import React from "react";
import PageKpis from "components/PageKpis";
import { Building2, Tag } from "lucide-react";

/**
 * PartnerCompaniesHeader (SOUND-293)
 * -------------------------------------------------------
 * Compact KPI strip rendered above the Companies list for
 * partner users only. Replaces the retired /dashboard KPIs.
 *
 * Expects `companies` array (current page) — matches the
 * shape returned by useCompanies().
 */
export default function PartnerCompaniesHeader({ companies = [] }) {
  const clients = companies.filter((c) => c.companyType === "client");
  const activeCount = clients.filter((c) => c.status === "active").length;
  const totalFeatures = clients.reduce(
    (sum, c) => sum + (c.features?.length || 0),
    0
  );

  return (
    <PageKpis
      items={[
        {
          label: "Total Clients",
          value: clients.length,
          icon: <Building2 />,
          tone: "brand",
        },
        {
          label: "Active",
          value: activeCount,
          icon: <Building2 />,
          tone: "success",
        },
        {
          label: "Features Enabled",
          value: totalFeatures,
          icon: <Tag />,
          tone: "info",
        },
      ]}
      columns={{ base: 1, md: 3, lg: 3 }}
    />
  );
}
